import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withKeys as _withKeys, createSlots as _createSlots, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "col-12 col-sm-6 col-md-4 s-filter--elem" }
const _hoisted_2 = { class: "col-12 col-sm-6 col-md-4 s-filter--elem" }
const _hoisted_3 = {
  key: 0,
  class: "col-12 col-sm-6 col-md-4 s-filter--elem"
}
const _hoisted_4 = {
  key: 1,
  class: "col-12 col-sm-6 col-md-4 s-filter--elem"
}
const _hoisted_5 = { class: "col-12 col-sm-6 col-md-4 s-filter--elem" }
const _hoisted_6 = { class: "col-12 col-sm-6 col-md-4 s-filter--elem" }
const _hoisted_7 = { class: "col-12 col-sm-6 col-md-4 s-filter--elem" }
const _hoisted_8 = { class: "col-12 col-sm-6 col-md-4 s-filter--elem" }
const _hoisted_9 = { class: "col-12 col-sm-6 col-md-4 s-filter--elem" }
const _hoisted_10 = { class: "row justify-center s-mb-xl" }
const _hoisted_11 = { class: "col-xs-12" }
const _hoisted_12 = { class: "s-mb-xl" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "flex flex-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_s_select = _resolveComponent("s-select")!
  const _component_s_input_date = _resolveComponent("s-input-date")!
  const _component_s_checkbox = _resolveComponent("s-checkbox")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_filters = _resolveComponent("filters")!
  const _component_s_icon = _resolveComponent("s-icon")!
  const _component_s_btn = _resolveComponent("s-btn")!
  const _component_s_input = _resolveComponent("s-input")!
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_service_skeleton_item = _resolveComponent("service-skeleton-item")!
  const _component_service_item = _resolveComponent("service-item")!
  const _component_not_found_data = _resolveComponent("not-found-data")!
  const _component_q_pagination = _resolveComponent("q-pagination")!
  const _component_s_page = _resolveComponent("s-page")!

  return (_openBlock(), _createBlock(_component_s_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_filters, {
        modelValue: _ctx.filterParams,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterParams) = $event)),
        class: "s-mb-xl s-card",
        "default-filters": _ctx.defaultFilterParams(),
        onApplyFilter: _ctx.applyFilter
      }, {
        default: _withCtx(({ filters }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_s_select, {
              modelValue: filters.formId,
              "onUpdate:modelValue": ($event: any) => ((filters.formId) = $event),
              filtering: "",
              options: _ctx.listFormSupport,
              label: "Форма поддержки",
              "option-value": "id",
              "option-label": "name",
              dense: "",
              clearable: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_s_select, {
              modelValue: filters.municipalAreas,
              "onUpdate:modelValue": ($event: any) => ((filters.municipalAreas) = $event),
              filtering: "",
              options: _ctx.listMunicipal,
              multiple: true,
              label: "Муниципальное образование",
              "option-value": "id",
              "option-label": "name",
              dense: "",
              clearable: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          (_ctx.isVisibleServiceKindId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_s_select, {
                  modelValue: filters.kindId,
                  "onUpdate:modelValue": ($event: any) => ((filters.kindId) = $event),
                  filtering: "",
                  options: _ctx.listKind,
                  label: "Территориальный уровень",
                  "option-value": "id",
                  "option-label": "name",
                  dense: "",
                  clearable: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isVisibleSegments)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_s_select, {
                  modelValue: filters.segments,
                  "onUpdate:modelValue": ($event: any) => ((filters.segments) = $event),
                  filtering: "",
                  options: _ctx.listSegment,
                  multiple: true,
                  label: "Сегмент",
                  "option-value": "id",
                  "option-label": "name",
                  dense: "",
                  clearable: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_s_select, {
              modelValue: filters.groupId,
              "onUpdate:modelValue": ($event: any) => ((filters.groupId) = $event),
              filtering: "",
              options: _ctx.listServiceGroups,
              label: "Группа мер поддержки",
              "option-value": "id",
              "option-label": "name",
              dense: "",
              clearable: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_s_input_date, {
              modelValue: filters.applicationStartsFrom,
              "onUpdate:modelValue": ($event: any) => ((filters.applicationStartsFrom) = $event),
              class: "s-form-input_wrapper",
              label: "Дата начала",
              dense: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_s_input_date, {
              modelValue: filters.applicationStartsTo,
              "onUpdate:modelValue": ($event: any) => ((filters.applicationStartsTo) = $event),
              class: "s-form-input_wrapper",
              label: "Дата окончания",
              dense: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_s_checkbox, {
              modelValue: filters.isOutside,
              "onUpdate:modelValue": ($event: any) => ((filters.isOutside) = $event),
              color: "brand",
              label: "Только внешние услуги",
              size: "md",
              name: "showExpired",
              "toggle-indeterminate": "",
              class: "s-checkbox"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_q_checkbox, {
              modelValue: filters.isInformation,
              "onUpdate:modelValue": ($event: any) => ((filters.isInformation) = $event),
              color: "brand",
              label: "Только информационные услуги",
              size: "md",
              name: "isInformation",
              "toggle-indeterminate": "",
              class: "s-checkbox"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "default-filters", "onApplyFilter"]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          (!_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_s_input, {
                key: 0,
                modelValue: _ctx.filterParams.name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterParams.name) = $event)),
                modelModifiers: { trim: true },
                clearable: "",
                label: "Поиск меры поддержки",
                class: "s-input--main_search",
                onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.applyFilter()), ["enter"]))
              }, _createSlots({
                prepend: _withCtx(() => [
                  _createVNode(_component_s_icon, { name: "app:search" })
                ]),
                _: 2
              }, [
                (!_ctx.isMobile)
                  ? {
                      name: "append",
                      fn: _withCtx(() => [
                        _createVNode(_component_s_btn, {
                          label: "Поиск меры поддержки",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.applyFilter()))
                        })
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["modelValue"]))
            : (_openBlock(), _createBlock(_component_q_skeleton, {
                key: 1,
                class: "s-skeleton",
                type: "QRange",
                animation: "fade"
              }))
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_ctx.isLoading || (_ctx.showLoading && _ctx.serviceList.length === 0))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["row service__wrapper q-col-gutter-sm", {
          'q-col-gutter-sm': _ctx.isMobile,
          'q-col-gutter-md': _ctx.isLaptop,
          'q-col-gutter-lg': _ctx.isDesktop,
        }])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.random([9, 12]), (_, k) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: k,
                  class: "col-xs-12 col-sm-6 col-md-4 row service__item-wrapper"
                }, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_service_skeleton_item, {
                        key: 0,
                        class: "col-xs-12"
                      }))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ], 2))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["row service__wrapper q-col-gutter-sm", {
          'q-col-gutter-sm': _ctx.isMobile,
          'q-col-gutter-md': _ctx.isLaptop,
          'q-col-gutter-lg': _ctx.isDesktop,
        }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceList, (service, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "col-xs-12 col-sm-6 col-md-4 row service__item-wrapper"
            }, [
              _createVNode(_component_service_item, {
                "is-loading": _ctx.isLoading,
                class: "col-xs-12",
                service: service,
                "icon-number": index % 10
              }, null, 8, ["is-loading", "service", "icon-number"])
            ]))
          }), 128))
        ], 2), [
          [_vShow, !_ctx.isLoading]
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        (!_ctx.isLoading && _ctx.serviceList.length === 0)
          ? (_openBlock(), _createBlock(_component_not_found_data, {
              key: 0,
              class: "col-xs-12 offset-xs-0 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-8 offset-lg-2"
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        (_ctx.pagination.rowsPerPage && _ctx.maxPagePagination > 1)
          ? (_openBlock(), _createBlock(_component_q_pagination, {
              key: 0,
              modelValue: _ctx.pagination.page,
              "onUpdate:modelValue": [
                _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pagination.page) = $event)),
                _ctx.proxyInputPagination
              ],
              max: _ctx.maxPagePagination,
              "max-pages": 5,
              color: "brand",
              "boundary-numbers": ""
            }, null, 8, ["modelValue", "max", "onUpdate:modelValue"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}